'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import CustomImage from '@components/CustomImage';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';
export default function OgamiBanner(props: MarketingPageComponentProps) {
  const bannerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'banner' && section.enabled
  );
  if (!bannerSection) return null;
  return (
    <Stack component="section" className={cn.ogamiBannerWrapper}>
      <Box className={cn.ogamiBannerInner}>
        <Box className={cn.ogamiBannerStory}>
          <Mobile>
            <CustomImage
              src={bannerSection.ogamiBannerMobile}
              alt={bannerSection.ogamiBannerMobile}
              width={800}
              height={1200}
            />
          </Mobile>
          <Desktop>
            <CustomImage
              src={bannerSection.ogamiBannerDesktop}
              alt={bannerSection.ogamiBannerDesktop}
              width={1200}
              height={800}
            />
          </Desktop>
        </Box>
        <Box className={cn.ogamiBannerContent}>
          <Box className={cn.ogamiContentInner}>
            <Box className={cn.ogamiBannerElement}>
              <Box className={cn.ogamiBannerHeader}>
                <Box className={cn.ogamiBannerHeader__logo}>
                  <CustomImage
                    src={bannerSection?.ogamiBannerLogo || ''}
                    alt="Ogami Logo"
                    width={768}
                    height={768}
                  />
                </Box>
                <Box className={cn.ogamiBannerHeader__heading}>
                  <Mobile>
                    <ParallaxText
                      variant="h2"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(bannerSection?.ogamiBannerHeadingMobile)}
                    </ParallaxText>
                  </Mobile>
                  <Desktop>
                    <ParallaxText
                      variant="h2"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(
                        bannerSection?.ogamiBannerHeadingDesktop
                      )}
                    </ParallaxText>
                  </Desktop>
                </Box>
              </Box>
              <Box className={cn.ogamiBannerControls}>
                <Box className={cn.ogamiBannerControls__content}>
                  <Mobile>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(bannerSection?.ogamiBannerContentMobile)}
                    </ParallaxText>
                  </Mobile>
                  <Desktop>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(
                        bannerSection?.ogamiBannerContentDesktop
                      )}
                    </ParallaxText>
                  </Desktop>
                </Box>
                <Box className={cn.ogamiBannerControls__button}>
                  <DynamicButton
                    className={cn.ogamiBannerButtonElement}
                    scrollToId="ogamiRegistrationID"
                  >
                    {bannerSection?.ogamiBannerButton}
                  </DynamicButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
